import React, { useEffect, useState } from "react";
import Footer from "../../Component/Footer";
import Header from "../../Component/Header";
import Menu from "../../Component/Menu";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import ProjectManagementServices from "../ProjectManagementServices";
import { spin } from "../../Common/NewLoader";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormLabel,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  Grid,
  TableRow,
  Typography,
  TextField,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Swal from "sweetalert2";
import { format } from "date-fns";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { id } from "date-fns/locale";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";

const formatDate = (dateString) => {
  return format(new Date(dateString), "dd-MM-yyyy");
};

const ProjectEstimationDetails = () => {
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState("");
  const [loader, setLoader] = useState(false);
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    GetProjectEstimationById();
  }, []);

  const GetProjectEstimationById = () => {
    setLoading(true);
    ProjectManagementServices.GetProjectEstimationById(params.id)
      .then((response) => {
        setData(response.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));

  }

  const handleApproveChange = (Status) => {
    if (!(
      (data.project !== null) &&
      (data.project.projectmanager.length > 0) &&
      (data.project.site.length > 0) &&
      (data.project.site.map(e => e.siteIncharges.length > 0)) &&
      (data.activities.length > 0) &&
      (data.activities.map(e => e.milestones.length > 0)) &&
      (data.activities.map(e => e.assignTos.length > 0)))
    ) {
      Swal.fire({
        title: `Are you sure you want to Approve This Estimation?`,
        text: ".",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#152f5f",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          let approvedata = {
            estimationId: data.estimationId,
            status: Status,
            updatedby: data.updatedby,
            tenantId: data.tenantId,
          }
          ProjectManagementServices.UpdatedEstimation(approvedata).then(() =>
            GetProjectEstimationById()
          )
        }
      });
    }
    else {
      if ((data.project === null)) {
        Swal.fire({
          title: `Add Project`,
          text: "",
          icon: "question",
          showConfirmButton: true,
          confirmButtonColor: "#152f5f"
        }).then()
      }

      if ((data.project.projectmanager.length === 0)) {
        Swal.fire({
          title: `Add Project Manager`,
          text: "",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#152f5f"
        }).then()
      }

      if ((data.project.site.length === 0)) {
        Swal.fire({
          title: `Add Site`,
          text: "",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#152f5f"
        }).then()
      }

      if ((data.project.site.map(e => e.siteIncharges.length === 0))) {
        Swal.fire({
          title: `Add Site Incharge`,
          text: "",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#152f5f"
        }).then()
      }

      if ((data.activities.length === 0)) {
        Swal.fire({
          title: `Add Activity`,
          text: "",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#152f5f"
        }).then()
      }

      if ((data.activities.map(e => e.milestones.length === 0))) {
        Swal.fire({
          title: `Add Activity Milestone`,
          text: "",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#152f5f"
        }).then()
      }

      if ((data.activities.map(e => e.assignTos.length === 0))) {
        Swal.fire({
          title: `Add Activity AssignTo`,
          text: "",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#152f5f"
        }).then()
      }
    }
  };

  const handleCancel = () => {
    Swal.fire({
      title: `Are you sure you want to Cancel This Estimation?`,
      text: ".",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#152f5f",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        let canceldata = {
          estimationId: data.estimationId,
          status: "Closed",
          updatedby: data.updatedby,
          tenantId: data.tenantId,
        }
        ProjectManagementServices.UpdateEstimationApproval(canceldata).then(() =>
          GetProjectEstimationById()
        )
      }
    });
  };

  return (
    <div>
      <Header />
      <Menu />
      <div className="content-wrapper">
        <div className="card card-info">
          <ol className="breadcrumb float-sm-right">
            <Link
              as="button"
              className="text-secondary"
              to="/projectestimation"
            >
              ❮ Back &nbsp;&nbsp;
            </Link>
            <li className="breadcrumb-item text-secondary">
              <Link to="/projectmanagement">Home</Link>
            </li>
            <li className="breadcrumb-item text-secondary">
              <Link to="/projectestimation">Project Estimation</Link>
            </li>
            <li className="breadcrumb-item active">
              Project Estimation Details
            </li>
          </ol>
          <section className="content">
            <div className="container-fluid">
              <div className="card-body">
                {loading === true ? (
                  <div className="text-center">{spin}</div>
                ) : (
                  <div className="row">
                    <div className="col-md-6">
                      <table style={{ margin: "1px 0" }}>
                        <tbody>
                          <tr>
                            <td style={{ paddingRight: "20px" }}>
                              Estimation Id
                            </td>
                            <td>:&nbsp;{data.estimationId}</td>
                          </tr>
                          <tr>
                            <td>Project</td>
                            <td>:&nbsp;{data.project.projectName}</td>
                          </tr>
                          <tr>
                            <td>Prepared By</td>
                            <td>:&nbsp;{data.preparedBy}</td>
                          </tr>
                          <tr>
                            <td>P.M Name</td>
                            <td>
                              :&nbsp;
                              {data.project.projectmanager[0].managerName}
                            </td>
                          </tr>
                          <tr>
                            <td>P.M No.</td>
                            <td>
                              :&nbsp;
                              {data.project.projectmanager[0].managerContactNo}
                            </td>
                          </tr>
                          <tr>
                            <td>P.M Email</td>
                            <td>
                              :&nbsp;
                              {data.project.projectmanager[0].managerEmail}
                            </td>
                          </tr>
                          <tr>
                            <td>Remarks</td>
                            <td>:&nbsp;{data.remark}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="col-md-6">
                      <table>
                        <tbody>
                          <tr>
                            <td>Client Name</td>
                            <td>
                              :&nbsp;
                              {data.project.clientassign[0]?.customerName}
                            </td>
                          </tr>
                          <tr>
                            <td style={{ paddingRight: "20px" }}>
                              Client Contact
                            </td>
                            <td>
                              :&nbsp;
                              {data.project.clientassign[0]?.customerContactNo}
                            </td>
                          </tr>
                          <tr>
                            <td>Client Email</td>
                            <td>
                              :&nbsp;
                              {data.project.clientassign[0]?.customerEmailId}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="col-md-12 mt-3">

                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          style={{ backgroundColor: "#e8ecef" }}
                        >
                          <FormLabel>
                            Site Details
                          </FormLabel>

                        </AccordionSummary>

                        <AccordionDetails>
                          {/* <div className="col-md-12"> */}
                          <Table
                            className="float-left table-border"
                            size="small"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell>Site Name</TableCell>
                                <TableCell>Site Code</TableCell>
                                <TableCell>Status</TableCell>

                                <TableCell>
                                  Incharge Details
                                </TableCell>

                                <TableCell>Site Address</TableCell>
                              </TableRow>
                            </TableHead>
                            {data.project.site &&
                              data.project.site.length > 0 &&
                              data.project.site.map((site) => (

                                <TableBody key={site.id}>
                                  <TableRow>
                                    <TableCell>{site.siteName}</TableCell>
                                    <TableCell>{site.siteCode}</TableCell>
                                    <TableCell>{site.status}</TableCell>

                                    <TableCell>
                                      {site.siteIncharges &&
                                        site.siteIncharges.length > 0 && (
                                          <Table
                                            className="float-left table-border border"
                                            size="small"
                                          >
                                            <TableHead>
                                              <TableRow>
                                                <TableCell>
                                                  Incharge Name
                                                </TableCell>
                                                <TableCell>
                                                  Contact Number
                                                </TableCell>
                                                <TableCell>
                                                  Email
                                                </TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              {site.siteIncharges.map(
                                                (incharge) => (
                                                  <TableRow
                                                    key={incharge.id}
                                                  >
                                                    <TableCell>
                                                      {
                                                        incharge.inchargeName
                                                      }
                                                    </TableCell>
                                                    <TableCell>
                                                      {
                                                        incharge.inchargeContactNo
                                                      }
                                                    </TableCell>
                                                    <TableCell>
                                                      {
                                                        incharge.inchargeEmail
                                                      }
                                                    </TableCell>
                                                  </TableRow>
                                                )
                                              )}
                                            </TableBody>
                                          </Table>
                                        )}
                                    </TableCell>

                                    <TableCell>
                                      {site.address},{site.city},{" "}
                                      {site.state}, {site.country}
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              ))}
                            {/* <table className="col-md-12">
                                <tbody>
                                  <tr>
                                    <td>Site Name</td>
                                    <td>{site.siteName}</td>
                                  </tr>
                                  <tr>
                                    <td>Site Code</td>
                                    <td>{site.siteCode}</td>
                                  </tr>
                                  <tr>
                                    <td>Status</td>
                                    <td>{site.status}</td>
                                  </tr>
                                  <tr>
                                    <td>Site Address</td>
                                    <td>{site.address}</td>
                                  </tr>
                                  <tr>
                                    <td></td>
                                    <td>{site.city}, {site.state}, {site.country}</td>
                                  </tr>
                                </tbody>
                              </table> */}


                            {/* <div className="col-md-12">
                              <FormLabel>Site Incharges:</FormLabel>
                              {site.siteIncharges && site.siteIncharges.length > 0 && (
                                <Table className="float-left table-border" size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>Incharge Name</TableCell>
                                      <TableCell>Contact Number</TableCell>
                                      <TableCell>Email</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {site.siteIncharges.map((incharge) => (
                                      <TableRow key={incharge.id}>
                                        <TableCell>{incharge.inchargeName}</TableCell>
                                        <TableCell>{incharge.inchargeContactNo}</TableCell>
                                        <TableCell>{incharge.inchargeEmail}</TableCell>

                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              )}
                            </div> */}
                          </Table>
                          {/* </div> */}

                        </AccordionDetails>
                      </Accordion>

                    </div>


                    <div className="col-md-12 mt-3">

                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          style={{ backgroundColor: "#e8ecef" }}
                        >


                          <div className="row justify-content-between w-100">

                            <fieldset className="form-group col-md-4">
                              <FormLabel>
                                Activities
                              </FormLabel>
                            </fieldset>

                            <div className="col-3">

                              <fieldset className="col-md">
                                <FormLabel>
                                  Start Date : {
                                    formatDate(
                                      new Date(Math.min(...data.activities.map(e => new Date(e.startDate))))
                                    )
                                  }
                                </FormLabel>
                              </fieldset>

                              <fieldset className="col-md">
                                <FormLabel>
                                  End Date &nbsp;&nbsp;: {
                                    formatDate(
                                      new Date(Math.max(...data.activities.map(e => new Date(e.endDate))))
                                    )
                                  }
                                </FormLabel>
                              </fieldset>

                            </div>

                            <fieldset className="col-md">
                              <FormLabel>
                                Estimated Days : {
                                  (() => {
                                    const startDate = new Date(Math.min(...data.activities.map(e => new Date(e.startDate))));
                                    const endDate = new Date(Math.max(...data.activities.map(e => new Date(e.endDate))));
                                    const diffTime = Math.abs(endDate - startDate);
                                    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                    return diffDays - 1;
                                  })()
                                }
                              </FormLabel>
                            </fieldset>


                            <fieldset className="form-group col-md-2">
                              <FormLabel className="text-secondary">
                                Total Budget: {(data.activities.reduce((sum, activity) => sum + activity.budget, 0))}
                              </FormLabel>
                            </fieldset>

                          </div>

                        </AccordionSummary>

                        <AccordionDetails>
                          <Table
                            className="float-left table-border border"
                            size="small"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell>Activity Name</TableCell>
                                <TableCell>Estimated Days</TableCell>
                                <TableCell>Start Date</TableCell>
                                <TableCell>End Date</TableCell>
                                <TableCell>Milestone Details</TableCell>
                                <TableCell> Budget</TableCell>
                              </TableRow>
                            </TableHead>

                            {data.activities &&
                              data.activities.length > 0 &&
                              data.activities.map((activity) => (

                                <TableBody key={activity.id}>
                                  <TableRow >
                                    <TableCell>
                                      {activity.activityName}
                                    </TableCell>
                                    <TableCell>
                                      {
                                        (() => {
                                          const startDate = new Date(Math.min(...activity.milestones.map(e => new Date(e.startDate))));
                                          const endDate = new Date(Math.max(...activity.milestones.map(e => new Date(e.endDate))));
                                          const diffTime = Math.abs(endDate - startDate);
                                          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                          return diffDays - 1;
                                        })()
                                      }
                                    </TableCell>
                                    <TableCell>
                                      {formatDate(activity.startDate)}
                                    </TableCell>
                                    <TableCell>
                                      {formatDate(activity.endDate)}
                                    </TableCell>

                                    <TableCell>
                                      {activity.milestones &&
                                        activity.milestones.length > 0 && (
                                          <Table
                                            className="float-left table-border border"
                                            size="small"
                                          >
                                            <TableHead>
                                              <TableRow>
                                                <TableCell>
                                                  Milestone Name
                                                </TableCell>
                                                <TableCell>
                                                  Estimated Days
                                                </TableCell>
                                                <TableCell>
                                                  Start Date
                                                </TableCell>
                                                <TableCell>
                                                  End Date
                                                </TableCell>
                                                <TableCell>Budget</TableCell>
                                              </TableRow>
                                            </TableHead>
                                            <TableBody>
                                              {activity.milestones.map(
                                                (milestone) => (
                                                  <TableRow key={milestone.id}>
                                                    <TableCell>
                                                      {
                                                        milestone.milestoneName
                                                      }
                                                    </TableCell>
                                                    <TableCell>
                                                      {
                                                        milestone.estimatedDays
                                                      }
                                                    </TableCell>
                                                    <TableCell>
                                                      {formatDate(
                                                        milestone.startDate
                                                      )}
                                                    </TableCell>
                                                    <TableCell>
                                                      {formatDate(
                                                        milestone.endDate
                                                      )}
                                                    </TableCell>
                                                    <TableCell>
                                                      {milestone.budget}
                                                    </TableCell>
                                                  </TableRow>
                                                )
                                              )}
                                            </TableBody>
                                          </Table>
                                        )}
                                    </TableCell>
                                    <TableCell>{activity.budget}</TableCell>
                                  </TableRow>
                                </TableBody>
                              ))}
                          </Table>
                        </AccordionDetails>
                      </Accordion>

                    </div>
                    {data.status !== "Closed" && (
                      <div className="col-md-12 mt-3">
                        <button
                          type="button"
                          className="btn btn-sm hovbuttonColour mr-2"
                          onClick={() => handleApproveChange("Active")}
                          disabled={loader}
                        >
                          Approve
                        </button>

                        <Link
                          type="button"
                          to={"/newprojectestimation"}
                          className="btn btn-sm hovbuttonColour mr-2"
                          state={data}
                        >
                          <i className="fas fa-pen" /> Edit
                        </Link>

                        <Link
                          as="button"
                          className="btn btn-sm deletebutton"
                          state={{ message: "Cancelled" }}
                          onClick={() => handleCancel()}
                        >
                          <b className="text-danger"> X </b>Cancel
                        </Link>
                      </div>
                    )}

                  </div>

                )}
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default ProjectEstimationDetails;
